import { render, staticRenderFns } from "./TaxPayerFilter.vue?vue&type=template&id=4e072e0b&scoped=true&"
import script from "./TaxPayerFilter.vue?vue&type=script&lang=js&"
export * from "./TaxPayerFilter.vue?vue&type=script&lang=js&"
import style0 from "./TaxPayerFilter.vue?vue&type=style&index=0&id=4e072e0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e072e0b",
  null
  
)

export default component.exports